import CardFirst from "./components/CardFirst"
import CardMiddle from "./components/CardMiddle"

import "./style.scss"

const AccompanyCard = () => (
  <div className="accompanyCard">
    <CardFirst />
    <CardMiddle />
  </div>
)
//
export default AccompanyCard
